import React from 'react';
import { motion } from 'framer-motion';
export function Quote() {
  return <section className="py-24 bg-usa-navy relative overflow-hidden" data-id="element-151">
      {/* Background accents */}
      <div className="absolute inset-0 opacity-10" data-id="element-152">
        <div className="absolute top-0 left-0 w-full h-full" style={{
        backgroundImage: 'radial-gradient(circle at 2px 2px, white 1px, transparent 0)',
        backgroundSize: '40px 40px'
      }} data-id="element-153"></div>
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10" data-id="element-154">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} data-id="element-155">
          <span className="text-usa-red font-display text-6xl md:text-8xl leading-none block mb-4" data-id="element-156">
            "
          </span>
          <blockquote className="text-2xl md:text-4xl font-display font-medium text-white leading-snug mb-8 tracking-wide" data-id="element-157">
            KNOWLEDGE WILL GIVE YOU POWER, BUT CHARACTER RESPECT.
          </blockquote>
          <cite className="text-usa-gold font-display text-xl tracking-widest not-italic" data-id="element-158">
            — BRUCE LEE
          </cite>
        </motion.div>
      </div>
    </section>;
}